import React from 'react';
import { Star, Phone } from 'lucide-react';
import { businessData } from '../mock';

const Reviews = () => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => {
      const fillPercentage = Math.min(Math.max(rating - index, 0), 1);
      return (
        <Star
          key={index}
          size={20}
          fill={fillPercentage >= 0.8 ? '#C4B5A0' : 'none'}
          stroke='#C4B5A0'
          style={{ 
            opacity: fillPercentage > 0 ? 1 : 0.3 
          }}
        />
      );
    });
  };

  return (
    <div className="page-reviews">
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">Anmeldelser</h1>
          <p className="page-subtitle">
            Hvad vores kunder siger om os
          </p>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="reviews-section">
        <div className="reviews-container">
          <div className="reviews-intro">
            <h2 className="reviews-intro-title">4,8 stjerner på Google Maps</h2>
            <p className="reviews-intro-text">
              Baseret på {businessData.totalReviews} anmeldelser fra rigtige kunder.
              Vores kunder værdsætter kvalitet, erfaring og den autentiske frisøroplevelse.
            </p>
          </div>

          <div className="reviews-grid">
            {businessData.reviews.map((review) => (
              <div key={review.id} className="review-card">
                <div className="review-stars">{renderStars(review.rating)}</div>
                <p className="review-text">"{review.text}"</p>
                <div className="review-author">
                  <span className="review-author-name">{review.author}</span>
                  <span className="review-date">{review.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="reviews-stats-section">
        <div className="reviews-stats-container">
          <div className="reviews-stat">
            <span className="reviews-stat-number">50+</span>
            <span className="reviews-stat-label">års erfaring</span>
          </div>
          <div className="reviews-stat">
            <span className="reviews-stat-number">1000+</span>
            <span className="reviews-stat-label">tilfredse kunder</span>
          </div>
          <div className="reviews-stat">
            <span className="reviews-stat-number">4,8★</span>
            <span className="reviews-stat-label">Google Maps vurdering</span>
          </div>
        </div>
      </section>

      {/* Testimonial Feature */}
      <section className="testimonial-feature-section">
        <div className="testimonial-feature-container">
          <div className="testimonial-feature-content">
            <div className="testimonial-quote-mark">"</div>
            <p className="testimonial-feature-text">
              Ole er en af de sidste af sin slags. Her får man tid og kvalitet
              – ikke masseproduktion. Det er en oplevelse hver gang.
            </p>
            <p className="testimonial-feature-author">– Lars K., kunde siden 2015</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="reviews-cta-section">
        <div className="reviews-cta-container">
          <h2 className="reviews-cta-title">Bliv en del af historien</h2>
          <p className="reviews-cta-text">
            Oplev selv hvorfor så mange kunder har været tro kunde i årevis
          </p>
          <a href={`tel:${businessData.phone}`} className="cta-button">
            <Phone size={20} />
            Ring for tid
          </a>
        </div>
      </section>
    </div>
  );
};

export default Reviews;